import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useMediaQuery, useTheme } from "@mui/material";
import { useContext, useEffect } from "react";
import { PaymentFormContext } from "../../../Shared/components/PaymentForm/PaymentFormContext";
import { BillingInformationContext } from "../../BillingInformation/BillingInformationContext";
import { UpdateOrderDeliveryPickupModalContext } from "../deliveryModalUtils/UpdateOrderDeliveryPickupModalContext";
import { AddNewAddressBtn } from "./AddNewAddressBtn";
import { SubmitNewAddressBtn } from "./SubmitNewAddressBtn";
/**
 *
 * @param initTabProps: InitTabProps
 * @param orderId: number;
 * @param orderInfo?: IOrderInfo;
 * @param orderStatus: Orders_SingleOrderInterface["OrderStatus"];
 * @param refetchOrders: () => void;
 * @param updateFunction: any; // FIXME
 * @param programId: number;
 * @param addressesData: UseAddressesReturn;
 * @param orderNumber: string;
 * @param setNewAddressData: Dispatch<SetStateAction<AddressDataType | null>>;
 * @param setPricingBreakdown: Dispatch<SetStateAction<PaymentFormPricingBreakdown>>;
 * @param setBalance: Dispatch<SetStateAction<Balance | undefined>>;
 * @param showAddresses: boolean;
 * @param onClose: () => void;
 * @param loading: boolean;
 * @param showModal: IUpdateOrderDeliveryModal["showModal"];
 * @param setShowModal: IUpdateOrderDeliveryModal["setShowModal"];
 * @param flowSku?: string;
 * @param disableAddAddressBtn: boolean;
 * @param setShouldDisplayPaymentForm: Dispatch<SetStateAction<boolean>>;
 * @returns
 */
export const DialogActionsComponent = (props) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"), { noSsr: true });
    const { updateFunction, loading: modalLoadingState, disableAddAddressBtn, shouldDisplayPaymentForm, setShouldDisplayPaymentForm, } = props;
    const { newAddressData, setNewAddressData } = useContext(UpdateOrderDeliveryPickupModalContext);
    const { balance, paymentMethod } = useContext(PaymentFormContext);
    const { paymentProcessor, paymentIntentId } = useContext(BillingInformationContext);
    useEffect(() => {
        setNewAddressData(Object.assign(Object.assign({}, newAddressData), { amount: balance === null || balance === void 0 ? void 0 : balance.remainingBalance, creditCardId: paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.id, paymentProcessor: paymentProcessor, paymentIntentId: paymentIntentId }));
    }, [balance, paymentMethod, paymentProcessor, paymentIntentId]);
    return (_jsxs(_Fragment, { children: [!isMobile ? _jsx(AddNewAddressBtn, { disabled: disableAddAddressBtn }) : null, _jsx(SubmitNewAddressBtn, Object.assign({}, props, { updateFunction: updateFunction, modalLoadingState: modalLoadingState, shouldDisplayPaymentForm: shouldDisplayPaymentForm, setShouldDisplayPaymentForm: setShouldDisplayPaymentForm }))] }));
};
